// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N0PGaWX5xuUKZsNDbFKX{padding:4px}.psPZlrSmZowv_qfMN8AN{color:var(--content-neutral-primary);align-items:center;gap:4px;font-weight:400;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatbotTooltip": `N0PGaWX5xuUKZsNDbFKX`,
	"chatbotTooltipLabel": `psPZlrSmZowv_qfMN8AN`
};
export default ___CSS_LOADER_EXPORT___;
